// Project.js
import React from 'react';
import ProjectsSlider from './ProjectsSlider';

const Project = () => {
  return (
    <div>
          <h1>Projects</h1>
          <div href="#project" style={{ textDecoration: 'none' }}> <ProjectsSlider /></div>
    </div>
  );
};

export default Project;
